import ConsumerReferralsList from './ConsumerReferralsList';

export default ConsumerReferralsList;
